<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <el-form-item label="学生">
          <span>{{data.studentName}}</span>
        </el-form-item>
        <el-form-item label="课程">
          <span>{{data.courseName}}</span>
        </el-form-item>
        <el-form-item label="视频机制" prop="supplementVideoType">
          <el-select
            placeholder="请选择"
            v-model="form.supplementVideoType"
            size="medium"
            class="course-score-selector"
            @change="onSupplementVideoTypeChange"
          >
            <el-option
              v-for="item in supplementVideoTypeList"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始周" prop="week">
          <el-select
            placeholder="请选择"
            v-model="form.week"
            size="medium"
            class="course-score-selector"
            :disabled="weekDisabled"
          >
            <el-option
              v-for="item in weekList"
              :key="item.Week"
              :label="item.Label"
              :value="item.Week"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="comment">
          <el-input
            placeholder="请输入备注"
            type="textarea"
            rows="3"
            v-model="form.comment"
            class="input-width"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="onSave">保存更新</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.label-col {
  width: 120px;
}
.checkbox-col {
  width: 100px;
  margin-left: 10px;
}
</style>

<script>
import { saveStudentSupplementVideo } from "../../service/student.service";
import { getSupplementVideoTypeList } from "../../service/common.service";
import { getWeekList } from "../../service/termManage.service";

export default {
  props: {
    data: {
      studentName: String,
      studentId: Number,
      courseId: Number,
      courseName: String,
      id: Number,
      week: Number,
      supplementVideoType: Number,
      termId: Number,
      yearCourseType: Number,
      isYearCourseChange: Boolean
    }
  },
  data() {
    return {
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      weekDisabled: false,
      weekList: [],
      supplementVideoTypeList: [],
      originalSupplementVideoType: 0,
      form: {
        week: 0,
        supplementVideoType: 0,
        comment: ""
      },
      rules: {
        week: [
          {
            required: true,
            message: "请输入开始周",
            trigger: "blur"
          }
        ],
        supplementVideoType: [
          {
            required: true,
            message: "请输入视频机制",
            trigger: "blur"
          }
        ],
        comment: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.loadWeekList();
    getSupplementVideoTypeList().then(result => {
      if (result && result.success) {
        this.supplementVideoTypeList = result.data;
      }
    });
    this.init();
  },
  methods: {
    init() {
      this.form.week = this.data.week;
      this.form.supplementVideoType = this.data.supplementVideoType;
      this.form.comment = "";
      this.originalSupplementVideoType = this.data.supplementVideoType;
      this.checkWeekDisabled();
      this.loadWeekList();
    },
    loadWeekList(){
      //是否年课下学期
      let isNextTerm = this.data.yearCourseType == 3;
      getWeekList(null, false).then(result => {
        if (result && result.success) {
          this.weekList = result.data;
        }
      });
    },
    onSupplementVideoTypeChange(){
      this.checkWeekDisabled();
    },
    checkWeekDisabled(){
      if (this.form.supplementVideoType == 4 || this.form.supplementVideoType == 5){
        this.weekDisabled = false;
      }else{
        this.weekDisabled = true;
      }
    },
    checkIsPriceChange(){
      if (this.data.isYearCourseChange){
        return false;
      }
      if (this.form.supplementVideoType != this.originalSupplementVideoType &&
        (this.form.supplementVideoType == 3 || this.form.supplementVideoType == 5)){
          return true;
      }
      return false;
    },
    getSupplementVideoTypeText(type){
      let item = this.supplementVideoTypeList.find(
          i => i.Key == type
        );
      if (!!item){
        let txt = "";
        if (type == 4){
          txt = `可以观看第${this.form.week}周后视频`;
        }else if (type == 5){
          txt = `可以观看第${this.form.week}周前视频`;
        }else{
          txt = item.Value;
        }
        return txt;
      }
      return "";
    },
    onSave() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (!isValid) {
        return;
      }

      if (this.checkIsPriceChange()){
        let originalText = this.getSupplementVideoTypeText(this.originalSupplementVideoType);
        let text = this.getSupplementVideoTypeText(this.form.supplementVideoType);
        let msg = `视频机制 ${originalText} 被修改为 ${text}, 会产生价格变化。请在实时数据搜索中进行操作。`;
        this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
              this.$router.push({
                path: "/frontDesk/salesQuery",
                query: {
                    studentName: this.data.studentName,
                    studentId: this.data.studentId,
                    courseId: this.data.courseId,
                    termId: this.data.termId,
                    courseType: 1,
                    week: this.form.week,
                    supplementVideoType: this.form.supplementVideoType
                }
            });
          })
          .catch(() => {});
        return;
      }

      this.submitBtnDisable = true;
      saveStudentSupplementVideo(
        this.data.id,
        this.form.week,
        this.form.supplementVideoType,
        this.form.comment
      )
        .then(result => {
          if (!!result) {
            if (result.success) {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              let supplementVideoTypeText = this.getSupplementVideoTypeText(this.form.supplementVideoType);
              let resultData = {
                week: this.form.week,
                supplementVideoType: this.form.supplementVideoType,
                supplementVideoTypeText: supplementVideoTypeText
              };
              this.$emit("success", resultData);
            } else {
              this.errorMessage = result.message;
              this.showError = true;
            }
          }
          this.submitBtnDisable = false;
        })
        .catch(() => {
          this.submitBtnDisable = false;
        });
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/supplementVideoEdit.vue